import { Action, Dispatch } from "redux";
import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import { actionTypes, AddFamilySharing, apiStatuses, Deferred, productInfoDeferred } from "./Actions";

const addFamilySharing: AddFamilySharing = (
  spidId: number,
  email: string,
  cellPhone:string,
  sig: string,
  referer?: string,
  source?: string,
) => (dispatch: Dispatch<Action>) => {
  const addFamilySharingDeferred = new Deferred();
  const failedCallback = (data: any) => {
    dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.ADD_FAMILY_SHARING
    });
    return addFamilySharingDeferred.reject(data);
  };

  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.ADD_FAMILY_SHARING
  });

  productInfoDeferred.promise.then(productInfo => {
    const requestInfo = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-score-spid-sig': sig
      },
      method: 'POST'
    }
    const refererParam = referer ? `&referer=${encodeURIComponent(referer)}` : '';
    const sourceParam = source ? `&source=${encodeURIComponent(source)}` : '';
    fetchWithUuid(
      `/bestilling/c/${
        productInfo.owningClient
      }/api/v2/ff/users/${spidId}/addFamilySharing.json?email=${encodeURIComponent(
        email
      )}&cellPhone=${
        encodeURIComponent(cellPhone)
      }${refererParam}${sourceParam}`,
      requestInfo
    )
      .then(checkError)
      .then(res => res.json())
      .then(data => {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.ADD_FAMILY_SHARING
        });
        return addFamilySharingDeferred.resolve(data);
      })
      .catch(failedCallback);
  }, failedCallback);

  return addFamilySharingDeferred.promise;
};

export default addFamilySharing;
